import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-13
 * @brief SEI 운영관리 - SiteInfo 개발
 *
 ********************************************************************/
import SitemViewMain from "./view/SiteViewMain";
function SitemMain(props) {
    const { workMode, handleOpenPop, onClickTab, isMobile } = props;
    return (_jsx(_Fragment, { children: workMode == "READ" && (_jsx(SitemViewMain, { handleOpenPop: handleOpenPop, onClickTab: onClickTab, isMobile: isMobile })) }));
}
export default SitemMain;
